import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import StorefrontIcon from "@mui/icons-material/Storefront";
import MonitorIcon from "@mui/icons-material/Monitor";
import PaymentsIcon from "@mui/icons-material/Payments";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import PrintIcon from "@mui/icons-material/Print";
import RouterIcon from "@mui/icons-material/Router";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import AppsIcon from "@mui/icons-material/Apps";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

/* ──────────────────────────────────────────────────────────────
 * Backend enum ReassignmentObjectType — index === numeric value.
 * Single source of truth: used by ReassignModal (grid picker) and
 * AssignationHistoriqueTab (timeline nodes + chips).
 * ────────────────────────────────────────────────────────────── */
export const OBJECT_TYPES = [
  { value: 0, label: "Caisse",      Icon: PointOfSaleIcon },
  { value: 1, label: "Borne",       Icon: StorefrontIcon },
  { value: 2, label: "Ecran",       Icon: MonitorIcon },
  { value: 3, label: "Monnayeur",   Icon: PaymentsIcon },
  { value: 4, label: "TPE",         Icon: CreditCardIcon },
  { value: 5, label: "Imprimante",  Icon: PrintIcon },
  { value: 6, label: "Reseau",      Icon: RouterIcon },
  { value: 7, label: "Bipper",      Icon: NotificationsActiveIcon },
  { value: 8, label: "Application", Icon: AppsIcon },
  { value: 9, label: "Autre",       Icon: MoreHorizIcon },
];

/** Safe lookup by numeric type; falls back to "Autre" then a placeholder. */
export const getObjectType = (type) =>
  OBJECT_TYPES[type] ??
  OBJECT_TYPES[9] ?? { value: type, label: "—", Icon: MoreHorizIcon };